module.exports = __webpack_public_path__ + "img/black.310a68ae.jpg";